var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "footer" } }, [
    _c("div", { staticClass: "logo", staticStyle: { display: "none" } }, [
      _c("img", { attrs: { src: _vm.url_logo } })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "name" }, [
      _c("span", {
        staticClass: "pp_link",
        domProps: { innerHTML: _vm._s(_vm.disp_privacy_policy) }
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "cr_text",
        domProps: { innerHTML: _vm._s(_vm.disp_copyright) }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "pgtop" }, [
      _c("img", {
        staticClass: "pgtop",
        staticStyle: { visibility: "hidden" },
        attrs: { src: _vm.url_pagetop }
      })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09f50cfa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09f50cfa","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/parts_com/Footer.vue
// module id = 660
// module chunks = 0 1